/* ff-enquiry.js
   Forest Art and Frame, 22 September 2026. Behaviour for sections/ff-enquiry.liquid:
   the relay for the two dead forms, the thank you state after Shopify redirects
   back, and the GA4 generate_lead push for Google Tag Manager. See the comment at
   the top of the section for the full reasoning. Loaded with defer, once per page
   however many enquiry sections the page carries. */
(function () {
  if (window.__ffqInit) return;
  window.__ffqInit = true;
  window.dataLayer = window.dataLayer || [];

  document.addEventListener('click', function (e) {
    var again = e.target && e.target.closest ? e.target.closest('[data-ffq-again]') : null;
    if (!again) return;
    var root = again.closest('[data-ffq]');
    if (!root) return;
    root.classList.add('ffq-show-fields');
    var input = root.querySelector('.ffq-input');
    if (input) input.focus();
  });

  /* A relayed form that Shopify bounced with an error would otherwise fail inside
     a hidden section. Show it, with the message and the typed values. */
  Array.prototype.forEach.call(document.querySelectorAll('[data-ffq][hidden]'), function (r) {
    if (!r.querySelector('.ffq-errors')) return;
    r.hidden = false;
    r.removeAttribute('aria-hidden');
    r.classList.remove('ffq-root--relay');
    r.classList.add('ffq-root--band');
    try { r.scrollIntoView({ block: 'start' }); } catch (err) {}
  });

  var RELAY_TRADE_URL = '/__ffq-relay/trade';

  function roots() { return Array.prototype.slice.call(document.querySelectorAll('[data-ffq]')); }
  function hostForm() {
    var r = roots()[0];
    return r ? r.querySelector('form.ffq-form') : null;
  }
  function setField(form, name, value) {
    var el = form.querySelector('[name="' + name + '"]');
    if (!el) {
      el = document.createElement('input');
      el.type = 'hidden';
      el.name = name;
      form.appendChild(el);
    }
    el.value = value == null ? '' : String(value);
  }

  /* Copies an adopted form into the real contact form and submits it through the
     browser, so Shopify's own spam protection sees an ordinary form submission. */
  function relaySubmit(kind, data) {
    var form = hostForm();
    if (!form) return false;
    setField(form, 'contact[Name]', data.name);
    setField(form, 'contact[email]', data.email);
    setField(form, 'contact[Phone]', data.phone);
    setField(form, 'contact[body]', data.body);
    setField(form, 'contact[Enquiry from]', data.location);
    Array.prototype.forEach.call(form.querySelectorAll('[required]'), function (el) { el.removeAttribute('required'); });
    form.setAttribute('action', (form.getAttribute('action') || '/contact').split('#')[0] + '#ffq-relay-' + kind);
    if (typeof form.requestSubmit === 'function') { form.requestSubmit(); } else { form.submit(); }
    return true;
  }

  /* 1. Commercial enquiry on /pages/for-business. Capture phase, so this runs before
     the inline handler that only ever opened the thank you modal. */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches || !f.matches('form.enquiry-form')) return;
    if (!hostForm()) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var lines = [], first = '', last = '', email = '', phone = '';
    Array.prototype.forEach.call(f.querySelectorAll('.form-group'), function (g) {
      var label = g.querySelector('.form-label');
      var ctl = g.querySelector('.form-control');
      if (!label || !ctl) return;
      var key = label.textContent.replace(/\s+/g, ' ').trim();
      var val = String(ctl.value || '').trim();
      var k = key.toLowerCase();
      if (k.indexOf('first name') === 0) first = val;
      else if (k.indexOf('last name') === 0) last = val;
      else if (k.indexOf('email') === 0) email = val;
      else if (k.indexOf('phone') === 0) phone = val;
      else if (val) lines.push(key + ': ' + val);
    });
    var btn = f.querySelector('[type="submit"]');
    if (btn) { btn.disabled = true; btn.textContent = 'Sending...'; }
    relaySubmit('business', {
      name: (first + ' ' + last).trim(),
      email: email,
      phone: phone,
      body: 'COMMERCIAL ENQUIRY\n' + lines.join('\n'),
      location: 'Commercial enquiry form, ' + location.pathname
    });
  }, true);

  /* 2. Trade application on /pages/trade-programme. Only when no real endpoint is
     configured, so a future Apps Script address in Theme settings takes over. */
  (function () {
    var cfg = window.FAF_CONFIG && window.FAF_CONFIG.contact;
    if (!document.getElementById('tradeApplyForm') || !cfg || cfg.tradeApplicationUrl || !hostForm()) return;
    cfg.tradeApplicationUrl = RELAY_TRADE_URL;
    var nativeFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (url !== RELAY_TRADE_URL) return nativeFetch.apply(window, arguments);
      var p = {};
      try { p = JSON.parse((init && init.body) || '{}'); } catch (err) { p = {}; }
      var skip = { firstName: 1, lastName: 1, email: 1, phone: 1, documentData: 1, source: 1, pageUrl: 1 };
      var lines = ['TRADE APPLICATION'];
      Object.keys(p).forEach(function (k) {
        if (skip[k]) return;
        var v = p[k];
        if (k === 'documents' && v && v.length) {
          v = v.map(function (d) { return d && d.name ? d.name : ''; }).join(', ') + ' (not attached, ask the applicant to email them)';
        } else if (Object.prototype.toString.call(v) === '[object Array]') {
          v = v.join(', ');
        }
        if (v !== '' && v != null) lines.push(k + ': ' + v);
      });
      var sent = relaySubmit('trade', {
        name: ((p.firstName || '') + ' ' + (p.lastName || '')).trim(),
        email: p.email || '',
        phone: p.phone || '',
        body: lines.join('\n'),
        location: 'Trade application, ' + location.pathname
      });
      return sent ? new Promise(function () {}) : Promise.reject(new Error('ffq relay unavailable'));
    };
  })();

  /* 2b. Quote requests, 30 September 2026. "Get a Quote" on the made to order
     mirrors and "Request a trade quote" on the trade page link to /pages/contact
     with ?quote=<what>. The piece is written into the message and into the
     Enquiry from field, so the customer does not have to retype it and Roxy can
     see at a glance what the quote is for. Skipped after a post, and never
     overwrites anything the customer has already typed. */
  (function () {
    var qp;
    try { qp = new URLSearchParams(location.search); } catch (err) { return; }
    var what = String(qp.get('quote') || '').replace(/[\u0000-\u001f<>]/g, '').trim().slice(0, 120);
    if (!what || qp.get('contact_posted') === 'true') return;
    var root = null;
    roots().forEach(function (r) {
      if (!root && !r.hidden && !r.classList.contains('ffq-root--relay')) root = r;
    });
    if (!root) return;
    var form = root.querySelector('form.ffq-form');
    if (!form) return;
    var trade = String(qp.get('kind') || '').toLowerCase() === 'trade';
    var body = form.querySelector('[name="contact[body]"]');
    if (body && !String(body.value || '').trim()) {
      body.value = trade
        ? 'Trade quote request\nItems and quantities: \nProject location: \nDeadline: '
        : 'Quote request: ' + what + '\nSize or wall width: \nSuburb or city: ';
    }
    setField(form, 'contact[Enquiry from]', (trade ? 'Trade quote: ' : 'Quote: ') + what);
    var first = form.querySelector('.ffq-input');
    setTimeout(function () {
      try { root.scrollIntoView({ block: 'start' }); } catch (err) {}
      if (first) { try { first.focus({ preventScroll: true }); } catch (err) {} }
    }, 150);
  })();

  /* 3. After Shopify redirects back. Shopify marks EVERY contact form on the page
     as posted, so the anchor decides whose submission it was. The booking page
     carries its own contact form, #bookForm, for quote requests: that one keeps
     its own thank you screen, this section shows its fields as normal, and the
     lead is still counted, labelled as a booking request. */
  var params = new URLSearchParams(location.search);
  if (params.get('contact_posted') !== 'true') return;
  var hash = (location.hash || '').slice(1);
  var relayed = hash.indexOf('ffq-relay-') === 0 ? hash.slice(10) : '';
  var all = roots();
  var mine = null, foreign = null;
  function cleanUrl() {
    params.delete('contact_posted');
    var qs = params.toString();
    try { history.replaceState(history.state, '', location.pathname + (qs ? '?' + qs : '') + location.hash); } catch (err) {}
  }
  if (relayed) {
    mine = all[0] || null;
  } else if (hash) {
    all.forEach(function (r) { if (!mine && r.getAttribute('data-ffq-form') === hash) mine = r; });
    if (!mine) {
      var other = document.getElementById(hash);
      if (other && other.tagName === 'FORM') foreign = other;
    }
  }
  if (!mine && !foreign) mine = all[0] || null;
  all.forEach(function (r) { if (r !== mine || relayed) r.classList.add('ffq-show-fields'); });
  if (foreign) {
    window.dataLayer.push({
      event: 'generate_lead',
      lead_type: foreign.id === 'bookForm' ? 'booking_request' : 'site_contact_form',
      form_location: foreign.id === 'bookForm' ? 'Booking page request form' : foreign.id,
      page_path: location.pathname
    });
    cleanUrl();
    return;
  }
  if (!mine || !mine.querySelector('[data-ffq-posted]')) return;

  if (relayed === 'business') {
    var modal = document.getElementById('enquiry-success');
    if (modal) { modal.style.display = 'flex'; document.body.style.overflow = 'hidden'; }
  } else if (relayed === 'trade') {
    var done = document.getElementById('apply-success');
    if (done) { done.hidden = false; document.body.style.overflow = 'hidden'; }
  } else {
    var msg = mine.querySelector('[data-ffq-posted]');
    if (msg && msg.focus) { try { msg.focus({ preventScroll: true }); } catch (err) {} }
  }

  window.dataLayer.push({
    event: 'generate_lead',
    lead_type: relayed === 'business' ? 'commercial_enquiry' : relayed === 'trade' ? 'trade_application' : 'quick_enquiry',
    form_location: relayed === 'business' ? 'Commercial enquiry form' : relayed === 'trade' ? 'Trade application' : (mine.getAttribute('data-ffq-location') || ''),
    page_path: location.pathname
  });
  cleanUrl();
})();